import { render, staticRenderFns } from "./Dashboard_2.vue?vue&type=template&id=298da614&scoped=true&"
import script from "./Dashboard_2.vue?vue&type=script&lang=js&"
export * from "./Dashboard_2.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_2.vue?vue&type=style&index=0&id=298da614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298da614",
  null
  
)

export default component.exports